import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Grid, IconButton } from '@chakra-ui/react';
import { useT } from '@progress-fe/core';
import { Input } from '../../../../inputs';
import { VirtualTable } from '../../../../tables';
import { Svg } from '../../../../base';
const FavoriteComponentsFC = ({ components, selectedComponents, onAddComponent, onDeleteComponent, onAddAllComponents, onDeleteAllComponent, removeFromFavorite, tableSx }) => {
    const [query, setQuery] = useState('');
    const { t } = useT();
    const columns = [
        { name: t('fields.name'), align: 'left' },
        { name: t('fields.formula'), align: 'left' },
        { name: t('fields.structure'), align: 'left' },
        {
            name: '',
            width: '24px',
            render: (id) => {
                if (!id) {
                    return undefined;
                }
                return (removeFromFavorite && (_jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "transparent", icon: _jsx(Svg, { size: "s12", name: "Minus" }), onClick: () => removeFromFavorite(id) })));
            }
        }
    ];
    const rows = components
        .filter((c) => c.name.toLowerCase().includes(query.toLowerCase()))
        .map((opt) => ({
        key: opt.uuid,
        isDisabled: false,
        values: [opt.name, opt.formula || '—', opt.structure || '—', opt.uuid],
        isSelected: selectedComponents.has(opt.uuid)
    }));
    return (_jsxs(Grid, { templateRows: "1fr", gap: "8px", children: [_jsx(Grid, { gridTemplateColumns: "1fr", gap: "8px", children: _jsx(Input, { name: "search", size: "xs", variant: "outline", value: query, placeholder: t('actions.search'), onChange: setQuery }) }), _jsx(VirtualTable, { isCheckboxShown: true, rows: rows, columns: columns, noItemsTitle: t('components.noFavorite'), tableSx: tableSx, onSelect: onAddComponent, onUnselect: onDeleteComponent, onSelectAll: onAddAllComponents, onUnselectAll: onDeleteAllComponent })] }));
};
export const FavoriteComponents = FavoriteComponentsFC;
//# sourceMappingURL=FavoriteComponents.js.map